import DayGroup from './component'
export default DayGroup
